import type { DownloadErrorCode, DownloadPhase } from './model'

type Messages = {
    phases: Record<DownloadPhase, string>
    errors: Record<DownloadErrorCode, string>
    cancel: string
    retry: string
    dismiss: string
    details: string
    storage: string
    source: string
    browser: string
    partial: string
    cleanup: string
    busy: string
}
export const downloadMessages: Record<'ru' | 'en', Messages> = {
    ru: {
        phases: {
            preparing: 'Подготовка архива',
            checking: 'Проверка файла и трафика',
            downloading: 'Скачивание',
            saving: 'Завершение передачи',
            cancelling: 'Отмена скачивания',
            succeeded: 'Скачивание завершено',
            failed: 'Не удалось скачать',
            cancelled: 'Скачивание отменено',
        },
        errors: {
            quota: 'Недостаточно доступного трафика. Пополните баланс и скачайте заново.',
            quotaCheck:
                'Данные о трафике пока недоступны. Обновите баланс и повторите попытку.',
            network:
                'Соединение прервано или сервер недоступен. Попробуйте скачать заново.',
            rateLimited:
                'Слишком много запросов. Подождите и повторите попытку.',
            access: 'Нет доступа к файлу. Проверьте авторизацию.',
            notFound:
                'Файл или задача больше не доступны. Обновите список файлов.',
            protocol:
                'Сервер вернул неожиданный ответ. Скачивание остановлено.',
            incomplete:
                'Получен неполный или неверный фрагмент файла. Скачайте заново.',
            changed: 'Файл изменился во время скачивания. Скачайте его заново.',
            decryption:
                'Не удалось расшифровать файл. Проверьте пароль шифрования.',
            write: 'Не удалось сохранить файл. Проверьте свободное место и разрешения.',
            saveTimeout:
                'Браузер перестал отвечать при сохранении файла. Перезагрузите страницу и скачайте заново.',
            memoryLimit:
                'В этом браузере безопасно сохраняются файлы до 64 МиБ. Для большего файла используйте браузер с потоковым сохранением.',
            archiveFailed: 'Сервер не смог подготовить архив.',
            archiveUnknown:
                'Не удалось подтвердить готовность архива. Он мог остаться в хранилище.',
        },
        cancel: 'Отменить',
        retry: 'Скачать заново',
        dismiss: 'Закрыть',
        details: 'Подробности',
        storage: 'Хранилище',
        source: 'Источник',
        browser:
            'Данные переданы браузеру. Проверьте сохранение в списке загрузок.',
        partial:
            'Если браузер оставил неполный файл, удалите его перед повторной попыткой.',
        cleanup:
            'Не удалось завершить очистку. Временный архив мог остаться в хранилище.',
        busy: 'Уже выполняется скачивание. Дождитесь завершения или отмените его в панели передач.',
    },
    en: {
        phases: {
            preparing: 'Preparing archive',
            checking: 'Checking file and traffic',
            downloading: 'Downloading',
            saving: 'Finishing transfer',
            cancelling: 'Cancelling download',
            succeeded: 'Download complete',
            failed: 'Download failed',
            cancelled: 'Download cancelled',
        },
        errors: {
            quota: 'Not enough available traffic. Top up and download again.',
            quotaCheck:
                'Traffic data is not available yet. Refresh the balance and try again.',
            network:
                'Connection interrupted or server unavailable. Try downloading again.',
            rateLimited: 'Too many requests. Wait and try again.',
            access: 'Access denied. Check your sign-in.',
            notFound:
                'The file or task is no longer available. Refresh the file list.',
            protocol: 'Unexpected server response. Download stopped.',
            incomplete:
                'An incomplete or invalid file chunk was received. Download again.',
            changed: 'The file changed during download. Download it again.',
            decryption:
                'Could not decrypt the file. Check your encryption password.',
            write: 'Could not save the file. Check available disk space and permissions.',
            saveTimeout:
                'The browser stopped responding while saving the file. Reload the page and download again.',
            memoryLimit:
                'This browser can safely save files up to 64 MiB. Use a browser with streaming save support for larger files.',
            archiveFailed: 'The server could not prepare the archive.',
            archiveUnknown:
                'Could not confirm archive completion. It may remain in storage.',
        },
        cancel: 'Cancel',
        retry: 'Download again',
        dismiss: 'Dismiss',
        details: 'Details',
        storage: 'Storage',
        source: 'Source',
        browser:
            'Data handed to your browser. Check that it was saved in your downloads list.',
        partial:
            'If your browser left an incomplete file, delete it before trying again.',
        cleanup:
            'Cleanup could not finish. A temporary archive may remain in storage.',
        busy: 'A download is already running. Wait for it to finish or cancel it in the transfers panel.',
    },
}
